export enum RoleEnum {
  R_SYSTEM = 'R_SYSTEM',
  R_PARTITION_ADMIN = 'R_PARTITION_ADMIN',
  R_PARTITION_USER = 'R_PARTITION_USER'
}
